// Wrap an intersection observer to trigger a callback the first time an element becomes visible.
export class OnVisibleObserver {
  constructor(opts) {
    this.callbacks = [] // stored as pairs of [element, callback]
    this.opts = opts
  }

  constructObserver = () => {
    this.observer = new IntersectionObserver(this.onObserve, this.opts)
  }

  handle = (el, fn) => {
    this.callbacks.push([el, fn])
    this.observer || this.constructObserver()
    this.observer.observe(el)
  }

  onObserve = (entries, observer) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const pair = this.callbacks.find(p => p[0] === e.target)
        if (!pair) {
          throw new Error(`OnVisibleObserver couldn't find registered callback for element ${e.target}`)
        }
        pair[1](e.target)
        observer.unobserve(e.target)
        this.callbacks = this.callbacks.filter(p => p[0] !== e.target)
      }
    })

    if (Object.keys(this.callbacks).length === 0) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}

